/**
 * @file     welcomeBack.ts
 * @readme   ../../CLAUDE.md
 * @purpose  English strings for the WelcomeBack component shown to returning users who already submitted a lead flow.
 */
export const welcomeBack = {
  title: 'Welcome back!',
  message: 'You have already submitted a request. Want to submit another?',
  summary: '{{name}} · {{flowLabel}}',
  summaryWithDetails: '{{name}} · {{flowLabel}} ({{details}})',
  startNew: 'Start a new submission',
  dismiss: "I'm all set",
  flowLabel: {
    buyer: 'Buyer property match',
    seller: 'Home value request',
    tenant: 'Tenant placement request',
  },
} as const;
